export class MoleculePanelOverviewHeaderMultiActivateDnsZoneActionComponent {
    public templateUrl = require('./multi-activate-dns-zone-action.html?external');
}
